export default IconBracketsContainEnd => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-brackets-contain-end" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M14 4h4v16h-4" />
  <path d="M5 16h.01" />
  <path d="M9 16h.01" />
  <path d="M13 16h.01" />
</svg>`;